<script setup lang="ts"></script>

<template>
  <div class="font-nature-variable relative text-white">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <div id="popover-portal" class="relative z-40" />
    <div id="tooltip-portal" class="relative z-50" />
  </div>
</template>
